import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SkillPointAccordion = ({
  skillPointListBlock = [],
  updateSkillPointBlock,
  onDeleteSkillPointBlock,
  setSkillPointIndex,
}) => {
  const { t } = useTranslation();

  return (
    <div className="accordion-item bg-transparent border-0">
      {/* ------ toggle accordion button start ------ */}
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseSix"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseSix"
        >
          {t("Skill Points")}
        </button>
      </h3>
      {/* ------ toggle accordion button end ------ */}
      {/* ----- skill point block list section start ----- */}
      <div
        id="panelsStayOpen-collapseSix"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          <div className="fields-group">
            <div className="fields d-flex flex-column gap-3">
              {/* ----- skill point list section start ------ */}
              {skillPointListBlock.map((skillBlock, index) => {
                return (
                  <div className="field" key={index}>
                    <div className="row g-3 align-items-center">
                      <div className="col-lg-4">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Skill")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark">
                            {skillBlock?.skillname}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Point")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark">
                            {skillBlock.points}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Total Experience")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark">
                            {skillBlock.experienceyear}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-1 action d-flex align-items-center justify-content-start gap-3">
                        <Link
                          to="#"
                          className="text-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#addSkillPointModal"
                          onClick={() =>
                            updateSkillPointBlock(skillBlock, index)
                          }
                        >
                          <span className="d-block material-symbols-outlined">
                            edit
                          </span>
                        </Link>
                        <button
                          type="button"
                          className="btn p-0 border-0 bg-transparent text-danger"
                          onClick={() => onDeleteSkillPointBlock(index)}
                        >
                          <span className="d-block material-symbols-outlined">
                            delete
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
              {/* ----- skill point list section end ------ */}
            </div>
            <Link
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#addSkillPointModal"
              onClick={() => {
                setSkillPointIndex(null);
              }}
              className="btn btn-outline-primary d-inline-flex align-items-center gap-1 mt-3"
            >
              <span className="d-block material-symbols-outlined">add</span>
              <span className="d-block">{t("Add Skill Points")}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillPointAccordion;
